/* eslint-disable */
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Remarkable } from 'remarkable';
import { format } from 'date-fns';
import UserIcon from '../../assets/icons/user_icon.svg';
import ShaiaCreate from '../../assets/shaia_create.png';
import useSessionStore from '../../store/useSessionStore';
import './bubble.css';
import { ControlDownloadResource } from './ControlDownloadResource';

const contentTest = `
"He encontrado el proceso para la actividad de inicio **Juego de Palitos: Resta**. A continuación se detalla el proceso completo:

<div class="session-structure">
  <h3>Estructura de sesión ENAd</h3>
  
  <div class="activity-phase-box">
    <h4>Inicio</h4>
    
    <h5>Juego de Palitos: Resta</h5>
    
    <div class="phase-box">
      <h6>Introducción y Maniobra con Palitos</h6>
      <p>El instructor les pide a los estudiantes que se sienten en parejas con 9 palitos. Cada pareja debe contar sus palitos y organizar sus 9 palitos para crear su propio diseño o figura en el piso. Luego, el instructor les da la tarea en voz alta de quitar y agregar palitos, y lo discute con ellos. Por ejemplo:
- Quitar 4 palitos de los 9 que les fueron dados y preguntarles, “¿Cuántos palitos les quedan?”.
- Agregar 2 palitos y preguntarles “¿Cuántos palitos tienen en total?”.
- Ahora, quitar 6 palitos y preguntarles “¿Cuántos palitos les quedan?”.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Seleccionar</button>
    </div> 
    
  </div>
</div>

Dado que esta actividad tiene solo una fase, la incluiré en la planeación porque es la única fase de la actividad. Vamos a avanzar a la siguiente actividad. 

Ahora, procedamos con la actividad de **desarrollo**: **Dinero Juguete: Comprensión de la División** ¿De acuerdo? 🎲✨"
`;

const contentTest2 = `
"¡Perfecto! Incluiremos la **Fase opcional: Evaluación y resumen** en la planeación de cierre con **Dinero de juguete: Resta con préstamo**. Esto permitirá a los estudiantes consolidar lo aprendido y reflexionar sobre su utilidad en situaciones cotidianas. 🎓

Aquí tienes la estructura completa de la sesión con todos los ajustes y transiciones:

<Fases_Selection>

<div class="session-structure">
  <h3>Estructura de sesión ENAd</h3>
  
  <div class="activity-phase-box">
    <h4>Inicio</h4>
    
    <h5>Nueve bien con palitos</h5>
    
    <div class="phase-box">
      <h6>Manejo inicial con palitos</h6>
      <p>El instructor pide a los estudiantes que se sienten en parejas con 9 palitos. Cada pareja cuenta sus palitos y organiza sus 9 palitos para crear su propio diseño o figura en el piso. Luego, el instructor les plantea tareas en voz alta como quitar o agregar palitos y discute los resultados con ellos. Ejemplo de tareas: quitar 4 palitos y preguntar cuántos quedan; agregar 2 palitos y preguntar cuántos tienen en total. El propósito es desarrollar el concepto de suma y resta usando palabras clave y objetos concretos. Además, el instructor puede preguntar a los estudiantes qué figura están haciendo, fomentando creatividad.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Seleccionar</button>
      </div>
    </div>
    
    <div class="transition-box">
      <h6>Transición sugerida</h6>
      <p>Para mantener el interés, pasamos de los palitos a un enfoque de grupo pequeño, donde empezaremos a implementar la técnica de préstamo usando palitos, ampliando así el concepto de las operaciones básicas hacia cálculos más complejos.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Generar una nueva transición</button>
        <button class="chat_option-button">Modificar transición</button>
      </div>
    </div>
    
  </div>
  
  <div class="activity-phase-box">
    <h4>Desarrollo</h4>
    
    <h5>Palitos y manojos: Resta con préstamo</h5>
    
    <div class="phase-box">
      <h6>Primera fase: Utilizando palitos</h6>
      <p>Los estudiantes usan palitos para representar cantidades y practicar la resta con préstamo. El instructor organiza a los estudiantes en grupos pequeños, entrega paquetes de palitos a cada grupo y proporciona una serie de operaciones de resta. Los estudiantes deben representar las cantidades a restar usando los palitos y proceder a resolver el problema redistribuyendo cuando sea necesario, tomando prestado según la necesidad. La atención del instructor se centra en guiar a los estudiantes en la técnica de préstamo correctamente y verificar si los resultados son consistentes.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Seleccionar</button>
      </div>
    </div>
    
    <div class="transition-box">
      <h6>Transición sugerida</h6>
      <p>El siguiente paso será aplicar estos mismos principios de préstamo a un contexto más cotidiano utilizando dinero de juguete, lo que les ayudará a los estudiantes a visualizar y aplicar las mismas técnicas en situaciones de la vida cotidiana.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Generar una nueva transición</button>
        <button class="chat_option-button">Modificar transición</button>
      </div>
    </div>
    
  </div>
  
  <div class="activity-phase-box">
    <h4>Cierre</h4>
    
    <h5>Dinero de juguete: Resta con préstamo</h5>
    
    <div class="phase-box">
      <h6>Fase opcional: Evaluación y resumen</h6>
      <p>Se evalúa el aprendizaje mediante la resolución de problemas individuales utilizando dinero de juguete, donde los estudiantes plantean y resuelven su propio problema de resta con préstamo. Aquí pueden intercambiar sus estrategias y resultados, fomentándose el aprendizaje peer-to-peer. Finalmente, el instructor recapitula las técnicas aprendidas, asegurando que todos comprendan los pasos para el préstamo en restas, respondiendo preguntas finales y proporcionando consejo adicional donde sea necesario.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Seleccionar</button>
      </div>
    </div>
    
    <div class="transition-box">
      <h6>Transición sugerida</h6>
      <p>Enfocarse en el intercambio de ideas y estrategias para resolver los problemas, estableciendo así una conexión con las experiencias de vida diaria que involucran el uso correcto del préstamo en cálculos, tanto colaborativos como individuales.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Generar una nueva transición</button>
        <button class="chat_option-button">Modificar transición</button>
      </div>
    </div>
  
  </div>
</div>

</Fases_Selection>

¡Espero que esta estructura sea de gran utilidad y enriquezca tu sesión! Si necesitas más cambios o soporte, ¡aquí estoy para ayudarte! 🧠✨"
`;

const contentTest3 = `
"Perfecto, ahora te ayudaré a seleccionar las actividades para tu sesión de matemáticas 🧮. La estructura de la sesión ENAd debe incluir 3 actividades: una para el inicio, otra para el desarrollo y una para el cierre. Dado que tienes estudiantes en los niveles de Resta y División y la agrupación es homogénea, buscaremos actividades adecuadas para estos niveles.

### Estructura de sesión ENAd 🗒️

<div class="session-structure">
  <h3>Inicio</h3>
  <p>NueveBien con Palitos</p>
  <p>Justificación de selección: Esta actividad es corta y permite a los estudiantes trabajar en la resta usando elementos concretos, ayudando a desarrollar su comprensión del concepto de sustracción en un ambiente participativo y lúdico【11:0†file-5AITy7izPmx8Z355NyL6r3oE】.</p>
  <div class="option-card-button-container">
    <button id="change-activity-start" class="chat_option-button">Reemplazar por una actividad diferente</button>
    <button id="explain-activity-start" class="chat_option-button">Explicar actividad</button>
  </div>

  <h3>Desarrollo</h3>
  <p>Palitos Manojos Resta con</p>
  <p>Justificación de selección: Esta actividad larga se centra en resolver problemas de resta con números de hasta 2 dígitos, utilizando palitos y manojos que facilitan el entendimiento de la operación de forma visual y concreta【11:2†file-znPPPHgvhscdwDgTLZ6Lbjz3】.</p>
  <div class="option-card-button-container">
    <button id="change-activity-development" class="chat_option-button">Reemplazar por una actividad diferente</button>
    <button id="explain-activity-development" class="chat_option-button">Explicar actividad</button>
  </div>

  <h3>Cierre</h3>
  <p>Dinero Juguete División con de</p>
  <p>Justificación de selección: Esta actividad corta permite comprender la división a través de la manipulación de dinero de juguete, relacionándolo con la vida cotidiana lo que aumenta el interés y la participación de los estudiantes【11:16†file-PUozxDe034p58IZnmXXLDWqj】.</p>
  <div class="option-card-button-container">
    <button id="change-activity-closure" class="chat_option-button">Reemplazar por una actividad diferente</button>
    <button id="explain-activity-closure" class="chat_option-button">Explicar actividad</button>
  </div>
</div>

Puedes cambiar de posición las actividades de inicio y cierre, reemplazar cualquier actividad por una diferente o incluso puedo explicarte alguna actividad si tienes dudas. ¿Estás de acuerdo con esta selección o prefieres modificar alguna? 😊"
`;

const content4 = `
¡Está bien! Vamos a seleccionar actividades que se alineen con el nivel y los temas que necesitas para tu grupo homogéneo. Aquí te presento una propuesta de actividades para tu sesión:

---

<div class="session-structure">
  <h3>Estructura de sesión ENAd</h3>

  <div class="activity-box">
    <h4>Inicio</h4>
    <p>**Chasquear y Aplaudir**</p>
    <p>Justificación de selección: Esta actividad es ideal para iniciar la sesión, ya que reforzará los conceptos básicos de números y sus valores posicionales, preparándolos mentalmente y generando un ambiente de juego y participación inicial[0].</p>
    <div class="option-card-button-container">
      <button id="change-activity-start" class="chat_option-button">Reemplazar por una actividad diferente</button>
      <button id="explain-activity-start" class="chat_option-button">Explicar actividad</button>
    </div>
  </div>

  <div class="activity-box">
    <h4>Desarrollo</h4>
    <p>**División con dinero de juguete**</p>
    <p>Justificación de selección: Una actividad algo más compleja que utiliza dinero de juguete para explicar la división de manera concreta y visual, perfecta para el desarrollo de la sesión. Esto permite detallar y practicar la operación la cual es parte del nivel que tiene el grupo[1].</p>
    <div class="option-card-button-container">
      <button id="change-activity-development" class="chat_option-button">Reemplazar por una actividad diferente</button>
      <button id="explain-activity-development" class="chat_option-button">Explicar actividad</button>
    </div>
  </div>

  <div class="activity-box">
    <h4>Cierre</h4>
    <p>**Palitos**</p>
    <p>Justificación de selección: Usamos palitos para facilitar la comprensión y práctica de la resta. Resulta una excelente manera de concluir la sesión, reforzando la habilidad anclada en el proceso concreto y cotidiano[2].</p>
    <div class="option-card-button-container">
      <button id="change-activity-closure" class="chat_option-button">Reemplazar por una actividad diferente</button>
      <button id="explain-activity-closure" class="chat_option-button">Explicar actividad</button>
    </div>
  </div>
</div>

---

Por favor, revisa esta selección y dime si estás de acuerdo o si prefieres realizar algún ajuste. ¡No dudes en pedirme una explicación sobre cómo se lleva a cabo alguna de las actividades! 😊
`;

const content5 = `
"¡Listo! He encontrado la información sobre el proceso de la actividad de inicio. Aquí está organizada de la siguiente manera: 📚✏️

### Matemáticas - Suma y resta oral

<div class="session-structure">
  <h3>Estructura de sesión ENAd</h3>
  
  <div class="activity-phase-box">
    <h4>Inicio</h4>
    
    <h5>Suma y resta oral</h5>
    
    <div class="phase-box">
      <h6>Para todo el salón</h6>
      <p>
        - El instructor debe dibujar una tabla de resta o de suma oral incompleta en el tablero y les pide a los estudiantes que dibujen la misma tabla en sus cuadernos. <br>
        - El instructor da una o dos demostraciones sobre cómo llenar las tablas. <br>
        - Luego, pide que dos estudiantes pasen al frente, divide la tabla en dos partes y les pide a los estudiantes que la llenen lo más rápido posible. <br>
        - Simultáneamente, les pide a los demás que llenen la tabla en sus cuadernos. <br>
        - El instructor discute la solución con los estudiantes y les pide que revisen sus respuestas. <br>
        - El instructor hace la demostración con 4 o 5 estudiantes hasta que todos puedan hacerlo.
      </p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Seleccionar</button>
      </div>
    </div>
    
    <div class="phase-box">
      <h6>Para grupos pequeños</h6>
      <p>
        - El instructor debe dividir la clase en grupos pequeños para que practiquen la actividad. El líder del grupo facilitará la práctica.
      </p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Seleccionar</button>
      </div>
    </div>
    
  </div>
</div>

Por favor, selecciona una fase del proceso de la actividad "Suma y resta oral" para incluir en la planeación. 🚀✨"
`;

const content6 = `

"¡Muy bien! 😊 Hemos elegido la fase "Para grupos pequeños" de la actividad **"Bien con nueve"** para integrar en nuestra planeación.

Con las fases de cada actividad seleccionadas, vamos a optimizar la planeación de la sesión asegurándonos de que fluya de manera efectiva y considerando cualquier retroalimentación disponible. Ahora mismo, voy a revisar y ajustar cada fase, integrando transiciones adecuadas. ¡Un momento por favor! ⏳

---

<Fases_Selection>

<div class="session-structure">
  <h3>Estructura de sesión ENAd</h3>

  <div class="activity-phase-box">
    <h4>Inicio</h4>
    
    <h5>Suma y resta oral</h5>
    
    <div class="phase-box">
      <h6>Para todo el salón</h6>
      <p>El instructor debe dibujar una tabla de resta o de suma oral incompleta en el tablero y les pide a los estudiantes que dibujen la misma tabla en sus cuadernos. Luego, hace una o dos demostraciones sobre cómo llenarlas y pide que dos estudiantes pasen al frente para llenar la tabla lo más rápido posible, mientras los demás lo hacen en sus cuadernos. Finalmente, discute la solución con los estudiantes y les pide que revisen sus respuestas. Se hacen varias demostraciones hasta que todos puedan hacerlo.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Explicar actividad</button>
      </div>
    </div>

    <div class="transition-box">
      <h6>Transición sugerida</h6>
      <p>Invita a los estudiantes a reflexionar sobre cómo las operaciones matemáticas de suma y resta pueden aplicarse a situaciones de la vida diaria, conectando así con la siguiente actividad práctica de “Resta con dinero de juguete”.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Generar una nueva transición</button>
        <button class="chat_option-button">Modificar transición</button>
      </div>
    </div>

  </div>
  
  <div class="activity-phase-box">
    <h4>Desarrollo</h4>
    
    <h5>Resta con dinero de juguete</h5>
    
    <div class="phase-box">
      <h6>Para todo el salón</h6>
      <p>El instructor debe escribir el problema de resta claramente en el tablero y leerlo simultáneamente. Por ejemplo: “Titi tiene 482 pesos y le va a regalar 355 pesos a su hermano Lolo, para que se compre un juguete. Después de haber entregado esa cantidad de dinero, ¿con cuánto dinero se quedará Titi?” El instructor vuelve a leer el problema y pide a un estudiante que pase al frente y lo lea en voz alta. Aplaude el esfuerzo del estudiante y plantea las cuatro preguntas guía: ¿Qué información nos da el problema? ¿Qué nos pide el problema? ¿Qué operación debemos usar? ¿Por qué? El instructor usa la tabla de valor posicional e invita a dos estudiantes para actuar como los personajes del problema y ayudar a resolverlo con el dinero de juguete. Llena la información de la tabla con las preguntas guía y discute cuántas unidades, decenas y centenas hay en los 355 pesos que le va a dar Titi a Lolo.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Explicar actividad</button>
      </div>
    </div>

    <div class="transition-box">
      <h6>Transición sugerida</h6>
      <p>Pide a los estudiantes observar cómo el uso de palitos, similar al dinero, puede ayudarles en su comprensión de conceptos matemáticos al introducir la actividad “Bien con nueve”.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Generar una nueva transición</button>
        <button class="chat_option-button">Modificar transición</button>
      </div>
    </div>

  </div>
  
  <div class="activity-phase-box">
    <h4>Cierre</h4>
    
    <h5>Bien con nueve</h5>
    
    <div class="phase-box">
      <h6>Para grupos pequeños</h6>
      <p>El instructor debe dividir la clase en grupos pequeños y pedirles que practiquen la actividad, facilitada por un líder del grupo.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Explicar actividad</button>
      </div>
    </div>
    
  </div>
</div>

</Fases_Selection>

---

Al implementar las actividades de esta manera, estamos maximizando el potencial de aprendizaje, fomentando la participación activa y asegurando que los estudiantes estén comprometidos y motivados durante toda la sesión. Cada transición facilita un flujo natural de una actividad a otra, lo que crea una experiencia de aprendizaje integrada. Si tienes alguna modificación que te gustaría hacer, ¡avísame! 😊"
`;

const content7 = `
"¡Perfecto! Continuemos entonces con una estructura propuesta para la sesión, considerando el objetivo de aprendizaje que deseas validar: "Aprender operaciones matemáticas básicas". Basándome en la información sobre tus sesiones anteriores y las sugerencias generales, aquí tienes una propuesta adaptada:

---

<Fases_Selection>

<div class="session-structure">
  <h3>Estructura de sesión ENAd</h3>
  
  <div class="activity-phase-box">
    <h4>Inicio</h4>
    
    <h5>Suma y resta introductoria</h5>
    
    <div class="phase-box">
      <h6>Fase: Para todo el salón</h6>
      <p>Comienza la sesión con una revisión oral de sumas y restas sencillas. Dibuja algunas operaciones básicas en el tablero e invita a los estudiantes a resolverlas de manera participativa. Esto ayudará a romper el hielo y a identificar el nivel general del grupo rápidamente.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Explicar actividad</button>
      </div>
    </div>
    
    <div class="transition-box">
      <h6>Transición sugerida</h6>
      <p>“Bien hecho, ahora que hemos recordado cómo funcionan estas operaciones, vamos a experimentar un poco más usando algunos materiales en grupo.”</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Generar una nueva transición</button>
        <button class="chat_option-button">Modificar transición</button>
      </div>
    </div>

    <h5>Resta con objetos</h5>
    
    <div class="phase-box">
      <h6>Fase: Para grupos pequeños</h6>
      <p>Cada grupo recibe un conjunto de objetos (como botones o palitos) para resolver problemas de resta prácticos. Esto fortalecerá la comprensión tangible de las operaciones matemáticas y fomentará la colaboración.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Explicar actividad</button>
      </div>
    </div>

    <div class="transition-box">
      <h6>Transición sugerida</h6>
      <p>“Ahora que hemos practicado juntos, intentemos resolver algunas operaciones por nuestra cuenta para ver qué hemos aprendido.”</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Generar una nueva transición</button>
        <button class="chat_option-button">Modificar transición</button>
      </div>
    </div>

    <h5>Practica Independiente</h5>
    
    <div class="phase-box">
      <h6>Fase: Práctica individual</h6>
      <p>Los estudiantes trabajan de manera individual para resolver operaciones matemáticas básicas con papel y lápiz, aplicando lo que aprendieron en las actividades grupales. Al finalizar, se revisan las respuestas juntos para resolver dudas.</p>
      <div class="option-card-button-container">
        <button class="chat_option-button">Explicar actividad</button>
      </div>
    </div>
    
  </div>
</div>

<elements>
<edit>
<word>
<pdf>
</elements>

<title>
Matemáticas: Noviembre 22, 2024
</title>

</Fases_Selection>

---

Este esquema de actividad es una propuesta versátil y adaptable que considera el refuerzo y la introducción gradual de conceptos matemáticos básicos. Si deseas ajustar alguna parte o discutir más sobre las actividades, ¡estoy aquí para ayudarte! 🤗📚"
`;
const referenceEnadClassPhase4Buttons = [
  'Genera una nueva transición entre el inicio y desarrollo',
  'Genera una nueva transición entre el desarrollo y cierre',
  'Quiero modificar la transición sugerida entre la actividad de inicio y desarrollo',
  'Quiero modificar la transición sugerida entre la actividad de desarrollo y cierre',
];

const referenceReplaceAcvitiyButtons = [
  'Reemplaza por una actividad diferente la actividad de inicio',
  'Reemplaza por una actividad diferente la actividad de desarrollo',
  'Reemplaza por una actividad diferente la actividad de cierre',
];

const Bubble = ({
  message,
  isEditorOn,
  children,
  handleOption,
  isDisabled = false,
  onDownloadPDF,
  onExportToWord,
  manualFormatedTime = null,
  forceDownloadControls = false
}) => {
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [isDonwloadResource, setIsDownloadResource] = useState(false);
  const [docTitle, setDocTitle] = useState('');
  const messageContainerRef = useRef(null);
  const { user } = useSessionStore();
  const isUser =
    message?.role === 'user' ||
    message?.type === 'human' ||
    message?.role === 'human';
  const isAi =
    message?.role === 'assistant' ||
    message?.type === 'ai' ||
    message?.role === 'ai';

  const currentMessage = message?.content || message?.data?.content;

  let formattedTime = message?.createdAt
    ? format(new Date(message?.createdAt), 'hh:mm a')
    : '';

  const md = new Remarkable({
    html: true,
    breaks: true,
    typographer: true,
  });

  const clickHandler = useCallback(
    (event) => {
      const currentSelection =
        messageContainerRef.current.querySelectorAll('.option-card');
      const currentSelectionPhaseBox =
        messageContainerRef.current.querySelectorAll('.phase-box');
      const activityBoxes =
        messageContainerRef.current?.querySelectorAll('.activity-box');
      const activityPhaseBoxes = messageContainerRef.current?.querySelectorAll(
        '.activity-phase-box'
      );

      const index = parseInt(event.target.dataset.index, 10);
      let contentUser = '';
      let isExplainAcitvity = false;
      console.log('index ', index);
      if (currentSelection.length) {
        currentSelection.forEach((element) => {
          const currentOptioCardSelected =
            element.classList.contains('selected');
          if (parseInt(element.dataset.index, 10) === index) {
            const getPTagElement = element.querySelector('p');
            console.log('getPTagElement ', getPTagElement);
            contentUser = getPTagElement.textContent;
          }
          if (currentOptioCardSelected) {
          }
        });
      }

      if (activityBoxes.length) {
        activityBoxes.forEach((element, activityBoxesIndex) => {
          const buttons = element.querySelectorAll('button');
          buttons.forEach((buttonElement, i) => {
            if (parseInt(buttonElement.dataset.index, 10) === index) {
              const getHTagElement = element.querySelector('p');
              contentUser = getHTagElement.textContent;
              if (buttonElement.textContent === 'Explicar actividad') {
                isExplainAcitvity = true;
                const getH5TagElement = element.querySelector('h5');
                contentUser = getH5TagElement.textContent;
              }
              if (
                buttonElement.textContent ===
                  'Reemplazar por una actividad diferente' &&
                activityBoxesIndex === 0
              ) {
                contentUser = referenceReplaceAcvitiyButtons[0];
              }
              if (
                buttonElement.textContent ===
                  'Reemplazar por una actividad diferente' &&
                activityBoxesIndex === 1
              ) {
                contentUser = referenceReplaceAcvitiyButtons[1];
              }
              if (
                buttonElement.textContent ===
                  'Reemplazar por una actividad diferente' &&
                activityBoxesIndex === 2
              ) {
                contentUser = referenceReplaceAcvitiyButtons[2];
              }
            }
          });
        });
      }

      if (currentSelectionPhaseBox.length) {
        currentSelectionPhaseBox.forEach((element) => {
          // const currentOptioCardSelected1 = element.classList.querySelector('option-card-button-container');
          if (parseInt(element.dataset.index, 10) === index) {
            const currentTitleH5 = element.querySelector('h5');
            if (currentTitleH5) {
              contentUser = `Seleccionar ${currentTitleH5.textContent}`;
            }
            const currentTitleH6 = element.querySelector('h6');
            if (currentTitleH6) {
              contentUser = `Seleccionar ${currentTitleH6.textContent}`;
            }
          }
        });
      }

      if (activityPhaseBoxes.length) {
        activityPhaseBoxes.forEach((element, activityPhaseBoxesIndex) => {
          // const currentOptioCardSelected1 = element.classList.querySelector('option-card-button-container');

          const buttons = element.querySelectorAll('button');
          buttons.forEach((buttonElement, i) => {
            if (parseInt(buttonElement.dataset.index, 10) === index) {
              const currentLastElement =
                activityPhaseBoxes[activityPhaseBoxesIndex - 1];
              const h4TagElement = currentLastElement
                ? currentLastElement.querySelector('h4')
                : null;
              if (
                h4TagElement &&
                h4TagElement.textContent === 'Inicio' &&
                buttonElement.textContent === 'Generar una nueva transición'
              ) {
                contentUser = referenceEnadClassPhase4Buttons[0];
              }
              if (
                h4TagElement &&
                h4TagElement.textContent === 'Desarrollo' &&
                buttonElement.textContent === 'Generar una nueva transición'
              ) {
                contentUser = referenceEnadClassPhase4Buttons[1];
              }
              if (
                h4TagElement &&
                h4TagElement.textContent === 'Inicio' &&
                buttonElement.textContent === 'Modificar transición'
              ) {
                contentUser = referenceEnadClassPhase4Buttons[2];
              }
              if (
                h4TagElement &&
                h4TagElement.textContent === 'Desarrollo' &&
                buttonElement.textContent === 'Modificar transición'
              ) {
                contentUser = referenceEnadClassPhase4Buttons[3];
              }
              if (buttonElement.textContent === 'Explicar actividad') {
                const getHTagElement = element.querySelector('h5');
                isExplainAcitvity = true;
                contentUser = getHTagElement.textContent;
              }
            }
          });
        });
      }

      setSelectedOptionIndex(index);

      // event.target.textContent = event.target.textContent === "Seleccionar" ? "Seleccionado" : "Seleccionar";
      console.log('contentUser ', contentUser);
      handleOption && handleOption(contentUser, isExplainAcitvity, index);
    },
    [handleOption]
  );

  const cleanMessageContent = (content) => {
    if (content?.includes('<planeación_semana') || content?.includes('<detalle_lunes')) {
      const messageInfoRegex = /<(planeación_semana|detalle_lunes)>([\s\S]*?)<\/\1>/;
      const match = currentMessage.match(messageInfoRegex);
      content = match ? match[2].trim() : '';
    }
    return content
      ?.replace(/\[\d*\]/g, '') // Eliminar [0], [1], etc.
      .replace(/【.*?】/g, '') // Eliminar 【...】
      .replace(/----/g, '')
      .replace(/Dame la respuesta en ingles y con buena gramatica/g, '')
      .replace(/Fase\s\d+\.?\d*:?/g, '') // Eliminar Fase 1_, Fase 1.1_, Fase 2, Fase 1:, etc.
      .replace(/Proceso\sFase\s\d+\.?\d*:?/g, ''); // Eliminar Proceso Fase 1_, Proceso Fase 1.1_, Proceso Fase 1:, etc.
  };

  useEffect(() => {
    const optionCards =
      messageContainerRef.current?.querySelectorAll('.option-card');
    const optionPhaseBox =
      messageContainerRef.current?.querySelectorAll('.phase-box');
    const buttons = messageContainerRef.current?.querySelectorAll(
      '.chat_option-button'
    );
    const activityBoxes =
      messageContainerRef.current?.querySelectorAll('.activity-box');
    const activityPhaseBoxes = messageContainerRef.current?.querySelectorAll(
      '.activity-phase-box'
    );

    if (activityBoxes) {
      activityBoxes.forEach((box, index) => {
        box.dataset.index = index; // Asigna el índice al dataset para acceso en el handler
        box.className = classNames('activity-box', {
          selected: index === selectedOptionIndex,
        }); // Aplica la clase selected basada en el estado
        const buttons = box.querySelectorAll('button');
        buttons.forEach((button, i) => {
          button.dataset.index = i; // Asigna el índice al dataset para acceso en el handler
          button.className = classNames('chat_option-button', {
            selected: i === selectedOptionIndex,
          }); // Aplica la clase selected basada en el estado
          button.addEventListener('click', clickHandler);
        });
        const h4 = box.querySelector('h4');
        if (h4) {
          if (h4.textContent.includes('Inicio')) {
            box.classList.add('box-init');
          } else if (h4.textContent.includes('Desarrollo')) {
            box.classList.add('box-develop');
          } else if (h4.textContent.includes('Cierre')) {
            box.classList.add('box-close');
          }
        }
      });
    }

    if (activityPhaseBoxes) {
      activityPhaseBoxes.forEach((box) => {
        const h4 = box.querySelector('h4');
        if (h4) {
          if (h4.textContent.includes('Inicio')) {
            box.classList.add('box-init');
          } else if (h4.textContent.includes('Desarrollo')) {
            box.classList.add('box-develop');
          } else if (h4.textContent.includes('Cierre')) {
            box.classList.add('box-close');
          }
        }
      });
    }

    if (optionCards) {
      optionCards.forEach((card, index) => {
        card.dataset.index = index; // Asigna el índice al dataset para acceso en el handler
        card.className = classNames('option-card', {
          selected: index === selectedOptionIndex,
        }); // Aplica la clase selected basada en el estado
      });
    }

    if (optionPhaseBox) {
      optionPhaseBox.forEach((card, index) => {
        card.dataset.index = index; // Asigna el índice al dataset para acceso en el handler
        card.className = classNames('phase-box', {
          selected: index === selectedOptionIndex,
        }); // Aplica la clase selected basada en el estado
      });
    }

    if (buttons) {
      buttons.forEach((button, index) => {
        // button.textContent = index === selectedOptionIndex ? "Seleccionado" : "Seleccionar";  // Actualiza el texto basado en el estado
        button.dataset.index = index; // Asigna el índice a dataset para acceso en el handler
        button.className = classNames('chat_option-button', {
          selected: index === selectedOptionIndex,
        }); // Aplica la clase selected basada en el estado
        button.addEventListener('click', clickHandler);
      });
    }

    return () => {
      if (buttons) {
        buttons.forEach((button) => {
          button.removeEventListener('click', clickHandler);
        });
      }
    };
  }, [message, clickHandler, selectedOptionIndex]);

  const createMarkup = (markdown) => {
    if (markdown?.includes('<div')) {
      return { __html: markdown };
    }
    const rawMarkup = md.render(markdown);
    return { __html: rawMarkup };
  };

  useEffect(() => {
    const currentMessage = message?.content || message?.data?.content;
    if (currentMessage?.includes('<elements>')) {
      setIsDownloadResource(true);
    } else if (currentMessage?.includes('<Fases_Selection>')) {
      setIsDownloadResource(true);
    } else if (currentMessage?.includes('<detalle_semana>')) {
      setIsDownloadResource(true);
    } else if (currentMessage?.includes('<planeación_semana>')) {
      setIsDownloadResource(true);
    } else {
      setIsDownloadResource(false);
    }
    if (currentMessage?.includes('<title')) {
      const messageInfoRegex = /<title>([\s\S]*?)<\/title>/;
      const match = currentMessage.match(messageInfoRegex);
      const currentTitle = match ? match[1].trim() : '';
      setDocTitle(currentTitle)
    }
  }, [message]);

  const cleanedContent = cleanMessageContent(currentMessage);
  return (
    <div
      className={classNames('max-w-full ', {
        'chat_conversation-thread-ai  ml-2': isAi,
        'chat_conversation-thread-user': isUser,
        'pointer-events-none': isDisabled,
        'opacity-[50%]': isDisabled,
      })}
    >
      <div
        className={classNames(
          'flex flex-col min-w-full max-w-full md:min-w-[85%] md:max-w-[87%]',
          {
            'order-2 items-start': isAi,
            'items-end': isUser,
          }
        )}
      >
        <div className={`chat_bubble_2-${isUser ? 'user' : 'ai'} `}>
          <div
            className={classNames('flex items-center ', {
              'gap-0 mb-1 flex-row-reverse': isUser,
              'justify-start gap-2 mb-4': isAi,
            })}
          >
            <div
              className={`chat_avatar-${
                isUser ? 'user_2 p-1' : 'ai_2 items-start'
              }`}
            >
              {isUser && <img className='' src={UserIcon} alt='Tú' />}
              {isAi && (
                <img
                  className='chat_avatar-ai-img '
                  src={ShaiaCreate}
                  alt='Sha.ia'
                />
              )}
            </div>
            <div className='text-[#3D96C2] text-sm flex items-center '>
              {isUser
                ? `${user?.first_name || ''} ${user?.last_name || ''}`
                : 'Shaia'}
            </div>
            <div
              className={classNames('text-white text-xs', {
                'mr-2': isUser,
              })}
            >
              {manualFormatedTime || formattedTime}
            </div>
          </div>
          <div
            className={classNames('bubble-message', {
              'xl:px-2': isEditorOn,
              'xl:px-10': !isEditorOn,
            })}
          >
            {children && children}
          {!children &&
            ['user', 'assistant', 'ai', 'human'].includes(
              message?.role || message?.type
            ) && (
              <>
                <div
                  className='chat-message-content-bubble'
                  ref={messageContainerRef}
                  dangerouslySetInnerHTML={createMarkup(cleanedContent)}
                />
                <ControlDownloadResource {...{isDonwloadResource,onExportToWord,cleanedContent,onDownloadPDF, docTitle}} />
              </>
            )}
            {forceDownloadControls? <ControlDownloadResource {...{isDonwloadResource:true,onExportToWord,cleanedContent,onDownloadPDF, docTitle}} /> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bubble;
